<template>
    <v-autocomplete
        :v-model="store"
        :label="storeInputLabel[lang]"
        :items="userStores"
        color="black"
        item-text="name"
        return-object
        outlined
        dense
        item-color="secondary"
        open-on-clear
        :loading="loading"
        required
        class="pt-0"
        :hide-no-data="!search || search.length < 3 || !!store"
        hide-selected
        clearable
        :search-input.sync="search"
        :filter="userStoresFilter"
        @input="$emit('input', $event)"
        @change="$emit('change')"
        @click="$emit('click')"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
    >
    </v-autocomplete>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
    name: "UserStoresSelect",

    props: {
        store: {
            type:  Object
        },
        loading: Boolean
    },
    data() {
        return {
            storeInputLabel: {
                el: "Επίλεξε ή αναζήτησε το κατάστημά σου",
                en: "Select or search for your store",
                it: "Selezionate o cercate il vostro negozio"
            },
            search: "",
        };
    },
    computed: {
        ...mapState(["userStores"]),
        lang: {
            get() {
                return this.$route.params.lang;
            },

            set(val) {
                if (val !== this.$route.params.lang)
                    this.$router.push(
                        `/${val}/` + this.$route.fullPath.slice(4)
                    );
            }
        }
    },

    methods: {
        ...mapActions(["getUserStores"]),

        ...mapMutations("storePanel", ["setLoading"]),

        userStoresFilter(item, queryText, itemText) {
            return (
                queryText.trim().length > 2 &&
                item.name
                    .trim()
                    .normalize("NFD")
                    .replace(/\p{Diacritic}/gu, "")
                    .toLocaleLowerCase()
                    .match(
                        new RegExp(
                            queryText
                                .trim()
                                .normalize("NFD")
                                .replace(/\p{Diacritic}/gu, "")
                                .toLocaleLowerCase(),
                            "i"
                        )
                    )
            );
        }
    },

    mounted() {
        this.getUserStores();
    },
    beforeDestroy() {
        window.removeEventListener("keydown", this.handler);
    }
};
</script>

<style lang="stylus" scoped></style>
